const isPlainObject = value =>
  Boolean(value) && Object.prototype.toString.call(value) === '[object Object]';

const deepMergeConfig = (base, override) => {
  if (!isPlainObject(base) || !isPlainObject(override)) {
    return override === undefined ? base : override;
  }

  return Object.keys(override).reduce(
    (merged, key) => {
      const overrideValue = override[key];

      if (overrideValue === undefined) {
        return merged;
      }

      if (isPlainObject(merged[key]) && isPlainObject(overrideValue)) {
        merged[key] = deepMergeConfig(merged[key], overrideValue);
      } else {
        merged[key] = overrideValue;
      }

      return merged;
    },
    { ...base }
  );
};

const fetchJsonConfig = async (url, options) => {
  const response = await fetch(url, options);

  if (!response.ok) {
    throw new Error(`Client config request failed with status ${response.status}`);
  }

  return response.json();
};

export default async config => {
  const useDynamicConfig = config.dangerouslyUseDynamicConfig;

  // Check if dangerouslyUseDynamicConfig enabled
  if (useDynamicConfig?.enabled) {
    // If enabled then get configUrl query-string
    let query = new URLSearchParams(window.location.search);
    let configUrl = query.get('configUrl');

    if (configUrl) {
      // validate regex
      const regex = useDynamicConfig.regex;

      if (configUrl.match(regex)) {
        return fetchJsonConfig(configUrl);
      } else {
        return null;
      }
    }
  }

  if (config.clientConfigUrl) {
    try {
      const clientConfig = await fetchJsonConfig(config.clientConfigUrl, {
        credentials: 'include',
      });
      return deepMergeConfig(config, clientConfig);
    } catch {
      console.warn('Failed to load client config; falling back to static config.');
      return null;
    }
  }

  return null;
};
